import { twMerge } from 'tailwind-merge'

interface GetComboboxClassNameProps {
  disabled: boolean
}

export const getComboboxTriggerClassName = ({
  disabled,
}: GetComboboxClassNameProps): string => {
  return twMerge(
    'w-full flex items-center justify-between px-3 h-9 text-sm bg-primary-50 dark:bg-default-dark border border-primary-200 dark:border-primary-800 rounded-md disabled:opacity-50 disabled:cursor-not-allowed',
    disabled
      ? 'opacity-50 cursor-not-allowed'
      : 'hover:bg-primary-100 dark:hover:bg-primary-900',
  )
}
